<template>
  <div>
    <hl-Select
      v-if="getCondensedRentalObjects.length"
      :options="rentalObjectsSelectList"
      :value="getCurrentRentalObjectOption.value"
      @change.native="updateValue"
    />

    <div v-else class="spinner-grow" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
import Select from '@modules/husleie-framework/src/components/forms/inputs/select/Select.vue';
import { InterestManagementCandidateApi } from '@modules/husleieapi2';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    'hl-Select': Select,
  },

  props: { rentalObjectId: [Number, String], prospectId: [Number, String] },

  computed: {
    ...mapGetters([
      'getRentalObject',
      'getRentalObjects',
      'getCondensedRentalObjects',
      'getLandlordId',
      'getCurrentIMId',
    ]),

    getCurrentRentalObjectOption() {
      const rO = this.getRentalObject(this.rentalObjectId);

      if (rO) {
        return {
          name: rO.details.name,
          value: rO.id,
        };
      }

      return false;
    },

    rentalObjectsSelectList() {
      const options = [];

      if (this.getCondensedRentalObjects) {
        for (const rO of this.getCondensedRentalObjects) {
          options.push({ name: rO.name, value: rO.id });
        }
      }

      return options;
    },
  },

  methods: {
    ...mapActions(['fetchCondensedRentalObjectList']),

    updateValue(e) {
      this.$emit('input', e.target.value);
    },
  },

  async created() {
    try {
      await this.fetchCondensedRentalObjectList(this.getLandlordId);
    } catch (error) {
      console.error(error);
      this.$toast('Kunne ikke hente utleieobjekter.', 'error');
    }
  },
};
</script>
